import React from 'react';
import PageSizeButton from '../../../../../../../components/PageSizeButton/PageSizeButton';
import { usePageSizeHandler } from '../../services/pageSize';
import { useStateSelector } from '../../stateManager';
import { selectPageSize } from '../../utils/selectors';

const PagesSize = () => {
  const pageSize = useStateSelector(selectPageSize);

  const onChange = usePageSizeHandler();

  return (
    <PageSizeButton
      pageSize={pageSize}
      setPageSize={onChange}
    />
  );
};

export default PagesSize;
